'use strict';

import { ObjectDetailsPageComponent } from './object-details-page/object-details-page';
import { objectDetailsPageState } from './object-details-page.states';

export const ObjectDetailsPageModule = angular.module('mx.sb.ObjectDetailsPage', []).component(objectDetailsPageState.component, ObjectDetailsPageComponent);
